import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { BUY_SELL_MAIN } from 'shared-modules/constants';
import { usePricesForBuySell } from 'shared-modules/services/hooks';
import ValueWithPrecision from '../ValueWithPrecision/ValueWithPrecision';

const CurrentPriceCellValue = memo(({ instrumentId, side }) => {
  const { sellPrice, buyPrice } = usePricesForBuySell({ currencyPair: instrumentId });

  let fixedValue = '';
  fixedValue = Number(side) === BUY_SELL_MAIN.BUY.ID ? sellPrice : buyPrice;
  return <ValueWithPrecision instrumentId={instrumentId} value={fixedValue} />;
});

CurrentPriceCellValue.propTypes = {
  instrumentId: PropTypes.string,
  side: PropTypes.string,
};

CurrentPriceCellValue.defaultProps = {
  instrumentId: '',
  side: '',
};

export default CurrentPriceCellValue;
